import { useCallback } from 'react';
import { useToast } from 'hooks/useToast';
import NotificationsAPI from 'services/API/NotificationsAPI';

export const useSendCompanyRequest = (companySearchText: string) => {
  const { renderCustomToast: toast } = useToast();

  const sendCompanyRequest = useCallback(async () => {
    try {
      await NotificationsAPI.postMissingCompany(companySearchText || '<empty>');
    } catch (err) {
      toast({
        title: 'Looks like something went wrong. Please try again in a couple of minutes',
        description: `${err}`,
        status: 'error',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast, companySearchText]);

  return sendCompanyRequest;
};
